import React from "react";
import { ScheduleTimes, SchedulePlaylists, Overlays } from ".";
import { InputBox } from "../../components";
import { ScheduleTimeInterface, ScheduleInterface, ApiHelper, ScreenInterface, PendingCommand, ToastHelper } from "../../helpers";
import { Row, Col, FormGroup, FormLabel, FormControl } from "react-bootstrap"

interface Props {
  screen: ScreenInterface,
  schedule: ScheduleInterface,
  scheduleTimes: ScheduleTimeInterface[],
  updatedCallback: () => void
}

export const ScheduleDetails: React.FC<Props> = props => {

  const [schedule, setSchedule] = React.useState<ScheduleInterface>(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [timesCommand, setTimesCommand] = React.useState<PendingCommand>(null);
  const [playlistsCommand, setPlaylistsCommand] = React.useState<PendingCommand>(null);
  const [overlaysCommand, setOverlaysCommand] = React.useState<PendingCommand>(null);

  const handleChange = (e: any) => {
    let s: ScheduleInterface = { ...schedule };
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "name": s.name = val; break;
    }
    setSchedule(s);
  }

  const validate = () => {
    if (schedule.name === "") {
      ToastHelper.error("Please enter a schedule name.");
      return false;
    }
    return true;
  }

  const handleSave = () => {
    if (validate()) {
      setIsSubmitting(true);
      ApiHelper.post<ScheduleInterface[]>("/schedules", [schedule])
        .then((data) => {
          setTimesCommand({ action: "save", parameter: (data?.[0]?.id || 0).toString() });
        })
        .catch(err => {
          console.error("Failed to save schedule:", err);
          ToastHelper.error("Failed to save schedule");
          setIsSubmitting(false);
        });
    }
  }


  const timesSaved = (scheduleId: number) => {
    setTimesCommand(null);
    setPlaylistsCommand({ action: "save", parameter: scheduleId.toString() } as PendingCommand);
  }

  const playlistsSaved = (scheduleId: number) => {
    setPlaylistsCommand(null);
    setOverlaysCommand({ action: "save", parameter: scheduleId.toString() } as PendingCommand);
  }

  const overlaysSaved = (scheduleId: number) => {
    setOverlaysCommand(null);
    setIsSubmitting(false);
    props.updatedCallback();
  }


  const getDeleteFunction = () => (schedule?.id > 0) ? handleDelete : undefined

  const handleDelete = () => {
    if (window.confirm("Are you sure you wish to permanently delete this schedule?")) {
      ApiHelper.delete("/schedules/" + schedule.id)
        .then(() => { props.updatedCallback(); })
        .catch(err => {
          console.error("Failed to delete schedule:", err);
          ToastHelper.error("Failed to delete schedule");
        });
    }
  }

  const handleCancel = () => { props.updatedCallback(); }


  const init = () => { if (props.schedule) setSchedule(props.schedule); }

  React.useEffect(init, [props.schedule])

  return (
    <InputBox headerIcon="far fa-clock" headerText={"Schedule Details - " + schedule?.name} saveFunction={handleSave} isSubmitting={isSubmitting} deleteFunction={getDeleteFunction()} deleteText="Delete schedule" cancelFunction={handleCancel} >
      <Row>
        <Col md={6}>
          <FormGroup className="mb-3">
            <FormLabel>Schedule Name</FormLabel>
            <FormControl id="name" value={schedule?.name} onChange={handleChange} />
          </FormGroup>
        </Col>
      </Row>
      <ScheduleTimes scheduleId={schedule?.id} scheduleTimes={props.scheduleTimes} saveCallback={timesSaved} pendingCommand={timesCommand as any} />
      <SchedulePlaylists scheduleId={schedule?.id} saveCallback={playlistsSaved} pendingCommand={playlistsCommand as any} screen={props.screen}   />
      <Overlays scheduleId={schedule?.id} saveCallback={overlaysSaved} pendingCommand={overlaysCommand as any} screen={props.screen} />

    </InputBox>

  );
};